import { render, staticRenderFns } from "./joinActivity.vue?vue&type=template&id=b8b9918e&scoped=true&"
import script from "./joinActivity.vue?vue&type=script&lang=js&"
export * from "./joinActivity.vue?vue&type=script&lang=js&"
import style0 from "./joinActivity.vue?vue&type=style&index=0&id=b8b9918e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8b9918e",
  null
  
)

export default component.exports